import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'car74',
  Description:
    'Here\'s all the online content included with your <strong>A-Level Chemistry Complete Revision and Practice</strong>.',
  Credits:
    `<p><strong>Exam Practice Questions:</strong><br>
Contributors: Michael Aicken, Mike Bossart, Ian H. Davis, John Duffy, Lucy Muncaster, David Paterson, Louise Watkins and Chris Workman.<br>
Clipart from Corel&reg;<br>
Illustrations by: Sandy Gardner Artist, email sandy@sandygardner.co.uk<br>
Data for graph on the ozone hole area is taken from NASA Ozone Watch.
</p>

<p><strong>Practice Papers:</strong><br>
Contributors: Sarah Binns, Megan Pollard and Louise Watkins.<br>
Illustrations by: Sandy Gardner Artist, email sandy@sandygardner.co.uk
</p>
<p>Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</p>`,};